// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"_3yiC5FqQCM1eAVbSgt9ZGY","modal_message":"_3bAfBFGgZGpYVVmCslej-2","modal_text":"_2409pD-d0AXfWzm1JCx0eS","btn_modal":"_3Bb9rE1xAB-ZWYaPmf90SE"};